/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { isError } from "@epic-mw/error-types";

import { getApiPath } from "../utils";

import { Account } from "./account.hooks";

export const fetchAccount = async (): Promise<Account> => {
	try {
		const response = await fetch(`${getApiPath()}/account`);
		const json: Account = await response.json();
		return json;
	} catch (err) {
		console.error("fetchAccount() failed to load", isError(err) && err.message);
		throw err;
	}
};
